<template>
  <div class="findly_lay_win">
    <img src="~assets/home/lvshi_lv_sample1.png" :style="imgStyle" />
    <div class="gl_lv_info">
      <div class="info1">
        <div class="tit FontSize16 ellipsis">
          {{item.lawyer_name}}律师 <span class="FontSize12">合伙人</span>
        </div>
        <div class="desc FontSize14">
          {{ item.goodat | toEllipsisFilter }}
        </div>
      </div>
      <div class="detail_info">
        <div class="phone center">
          <svg-icon icon-class="dianhua" class="svgimg" />
          {{item.lawyer_mobile}}
        </div>
        <router-link to="/question/onlitform">
			<div class="btn center">在线咨询</div>
		</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    imgStyle: {
      type: Object,
      default() {
        return { width: "225px", height: "300px" };
      },
    },
	item:{
		type:Object,
	}
  },
};
</script>

<style lang="scss" scoped>
.findly_lay_win {
  &:hover {
    .gl_lv_info {
      .info1 {
        display: none;
      }
      .detail_info {
        display: block;
      }
    }
  }
  .gl_lv_info {
    width: 100%;
    height: 80px;

    .info1 {
      padding: 16px 12px;
      text-align: center;
      color: #999;
      .tit {
        font-size: 18px;
        color: #282828;
        span {
          margin-left: 10px;
          font-size: 12px;
        }
      }
      .desc {
        margin-top: 6px;
        font-size: 14px;
      }
    }

    .detail_info {
      display: none;
      width: 100%;
      height: 100%;
      background: fff;
      box-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.08);
      color: #282828;
      padding-top: 16px;
      .phone {
        cursor: pointer;
        .svgimg {
          font-size: 14px;
          color: #1375ff;
          margin-right: 4px;
        }
      }
      .btn {
        width: 82px;
        height: 23px;
        background: #f25618;
        color: #fff;
        font-size: 14px;
        border-radius: 5px;
        margin: 10px auto;
        cursor: pointer;
      }
    }
  }
}
</style>